import {
  fetchWrapper,
  handleResponse,
  buildOpts,
  hcUrl,
  transformProductsResponse,
  transformPantryCartResponse,
  transformInventoryResponse,
  formatBody,
} from 'services/RequestService/helpers';

const buildLineItemParms = lineItem => ({
  lineItemsAttributes: [
    {
      id: lineItem.id,
      kroger_id: lineItem.productId,
      quantity: lineItem.quantity || 1,
      _destroy: lineItem.remove || false,
    },
  ],
});

const transformPantryParams = ({ cartId, lineItem, addressAttributes }) => ({
  id: cartId,
  ...(lineItem ? buildLineItemParms(lineItem) : {}),
  ...(addressAttributes ? { addressAttributes } : {}),
});

const getProducts = async () => {
  const response = await fetchWrapper(hcUrl('/pantry/products'), buildOpts());
  return handleResponse(response, transformProductsResponse);
};

const getCart = async () => {
  const response = await fetchWrapper(hcUrl('/pantry/user/cart'), buildOpts());
  return handleResponse(response, transformPantryCartResponse);
};

const getChargedCart = async ({ params }) => {
  const response = await fetchWrapper(hcUrl(`/pantry/carts/${params.id}`));
  return handleResponse(response, transformPantryCartResponse);
};

const createCart = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl('/pantry/carts'),
    buildOpts({
      method: 'POST',
      body: formatBody({ pantryCart: transformPantryParams(params) }),
    })
  );
  return handleResponse(response, transformPantryCartResponse);
};

const updateCart = async ({ params }) => {
  const { cartId, ...restParams } = params;
  const response = await fetchWrapper(
    hcUrl(`/pantry/carts/${cartId}`),
    buildOpts({
      method: 'PATCH',
      body: formatBody({ pantryCart: transformPantryParams(restParams) }),
    })
  );
  return handleResponse(response, transformPantryCartResponse);
};

const createCheckout = async ({ params }) => {
  const { cartId, ...restParams } = params;
  const response = await fetchWrapper(
    hcUrl(`/pantry/carts/${cartId}/checkouts`),
    buildOpts({
      method: 'POST',
      body: formatBody({ checkouts: restParams }),
    })
  );
  return handleResponse(response, transformPantryCartResponse);
};

const getInventory = async ({ params: { productIds } }) => {
  const response = await fetchWrapper(
    hcUrl(`/pantry/products/${productIds.join(',')}`),
    buildOpts()
  );
  return handleResponse(response, transformInventoryResponse);
};

export {
  getProducts,
  createCheckout,
  getCart,
  createCart,
  updateCart,
  getInventory,
  getChargedCart,
};
